/* eslint-disable no-cond-assign */

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import * as ProposalNS from '../../Proposal';
import { MATURITY_CATEGORIES, MATURITY_CATEGORIES_FACTSET, ASSET_ALLOCATION_GROUPS } from '../../../../utils/constants';
import { validateAppMode } from '@/utils/enterprise';

import * as ProposalElementNS from '../../ProposalElements';

import { DataPoints, DataPointResponse } from '../DataPoints';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { PROPOSAL_DISCLAIMERS } from '../../utils/constants';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { NotApplicableCell, PercentageCell } from '../../../../views/components/cells';
import AppMode from '@/types/app-mode';
import { Dictionary } from 'lodash';

export default class FixedIncomeMaturityDAO extends ComparisonItemBasedProposalDAO {
  fixedIncomeMaturityCategories: Dictionary<string> = MATURITY_CATEGORIES;

  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    const dao = new FixedIncomeMaturityDAO(proposal, proposalElement);
    const isModeFactSet = validateAppMode(proposal.appUser.appConfig.mode, AppMode.FACT_SET);
    if (isModeFactSet) {
      dao.fixedIncomeMaturityCategories = MATURITY_CATEGORIES_FACTSET;
    }
    return dao;
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['MATURITY_COLORS'];
  }

  // eslint-disable-next-line class-methods-use-this
  private hasEmptyMaturity(itemDAO: ComparisonItemDAO) {
    const fixedIncome = DataPoints.getAssetAllocationTotalsByCategory(itemDAO.item, ASSET_ALLOCATION_GROUPS.FIXED_INCOME).response;
    return fixedIncome > 0 && itemDAO.item.allocations && itemDAO.item.allocations.maturity && itemDAO.item.allocations.maturity.length === 0;
  }

  protected build(): void {
    const daoConfig = this.proposalElement.DAO as ProposalNS.FixedIncomeMaturityConfig;

    let itemDAO: ComparisonItemDAO | null = null;

    while ((itemDAO = this.nextItem()) !== null) {
      for (const [key, value] of Object.entries(this.fixedIncomeMaturityCategories)) {
        const dpResponse: DataPointResponse<number | undefined> = DataPoints.getMaturityAllocationByKey(itemDAO.item, value);
        let fieldName: string = this.formatMessage(`MaturityAllocations.${value}`);
        if (daoConfig.rollIntoOther && this.hasEmptyMaturity(itemDAO) && key.toUpperCase() === MATURITY_CATEGORIES.Other.toUpperCase()) {
          dpResponse.response = 100;
          this.addDisclaimerKeys([PROPOSAL_DISCLAIMERS.ROLL_INTO_OTHER], itemDAO.item);
          fieldName += '*';
        }
        this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);
        const { response } = dpResponse;

        if (daoConfig.rollIntoOther && key === MATURITY_CATEGORIES.Other && response !== undefined && response > 0) {
          this.addDisclaimerKeys([PROPOSAL_DISCLAIMERS.ROLL_INTO_OTHER], itemDAO.item);
        }

        const field = new ProposalFieldDAO(fieldName, response !== undefined ? response.toFixed(2) : 0, ProposalStyleClassNames.ProposalTableContent);
        field.cellType = response === undefined ? NotApplicableCell : PercentageCell;
        field.key = key;
        this.addFieldDAO(itemDAO, field);
        let color: string | undefined;
        if (this.colorsDict) {
          color = this.colorsDict[key];
        }
        this.addFieldName(fieldName, ProposalStyleClassNames.ProposalTableContent, color);
      }
    }
  }
}
